import { useContext } from "react";

import { ContextApp } from "./app.context";

export const useContextApp = () => useContext(ContextApp);
